<template>
  <CRow class="mt-2">
    <CCol>
      <CRow align="start">
        <CCol md="2" class="my-auto py-auto">
            <CSelect class="my-auto py-auto" id="per-page-select" :value.sync="perPageKu" @change="changePerPage()" :options="pageOptions" />
        </CCol>
        <CCol md="4" class="my-auto py-auto">
          <span> {{ $store.state.pagination.perHalaman }}</span> <span> | </span> 
          <span> {{ $store.state.pagination.label_tampilkan }} {{ entriesaw }} {{ $store.state.pagination.label_sampai }}
          {{ entriesak }} {{ $store.state.pagination.label_dari }} {{ totalRows }} {{ $store.state.pagination.label_entri }} </span>
        </CCol>
        <CCol md="6" offset-md="4" class="mt-2">
          <CPagination class="" margin="0px" align="end" :activePage="currentPage" :pages="totalPages" :per-page="perPage" @update:activePage="updatePage($event)"></CPagination>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>
<script>
export default {
  props: [
    'perPage',
    'entriesaw',
    'entriesak',
    'totalRows',
    'currentPage',
  ],
  emits: [
    'changeVar'
  ],
  data() {
    return {
      pageOptions: [
          { value: 2, text: 2 },
          { value: 10, text: 10 },
          { value: 25, text: 25 },
          { value: 50, text: 50 },
          { value: 100, text: 100 },
      ],
      perPageKu: 10,
    };
  },
  computed: {
    totalPages(){
      return Math.ceil(this.totalRows / this.perPage)
    }
  },
  watch: {
    perPage(newVar, oldVar){
      if(newVar != oldVar){
        this.perPageKu = newVar
      }
    }
  },
  methods: {
    test(x){
      console.log('test', x)
    },
    changePerPage(){
      this.$emit('changeVar', {name: 'perPage', data: this.perPageKu})
    },
    updatePage(x) {
      let vm = this;
      let currentPage = 1
      if (x < 1) {
          currentPage = 1;
      } else if (x > vm.totalPages) {
          currentPage = vm.totalPages;
      } else {
          currentPage = x;
      }
      vm.$emit('changeVar', {name: 'currentPage', data: currentPage})
    },
  },
};
</script>

<style scoped>
</style>
